// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"165":"31e93d52","796":"a2683943"}[chunkId] + ".chunk.js";
};